import { email, required } from '../../../../utils/validators';

export const constraints = {
  firstName: [required()],
  lastName: [required()],
  email: [required(), email()],
  phone: [required()],
};

export type FormData = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};
